export default __webpack_public_path__ + "static/media/starFilled.0297a751.svg";